<div
  class="relative rounded-2xl border bg-slate-900 transition overflow-hidden p-4 min-h-[160px]"
  [class.border-slate-800]="!isDraggingOver && !disabled"
  [class.border-sky-400]="isDraggingOver"
  [class.bg-sky-950/20]="isDraggingOver"
  [class.opacity-60]="disabled"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">

  <div
    #editor
    contenteditable="true"
    (input)="onEditorInput()"
    (blur)="onEditorBlur()"
    (click)="onEditorClick($event)"
    class="editor-surface w-full bg-transparent text-sm leading-6 text-slate-100 outline-none min-h-[130px] resize-y placeholder:text-slate-600"
    [attr.data-placeholder]="placeholder"></div>

  @if (isDraggingOver) {
    <div class="pointer-events-none absolute inset-0 flex items-center justify-center rounded-2xl bg-sky-950/90 backdrop-blur-xs text-sky-300 font-medium text-xs gap-2 z-10">
      <app-icon icon="mdi-cloud-upload-outline" class="text-xl"></app-icon>
      <span>Drop file to upload & attach to description</span>
    </div>
  }
</div>
